import { S6Response } from "./response";

export class S6Request {
    private options: S6RequestConfig = {};

    private constructor(options: S6RequestConfig) {
        this.options = options;
    }

    public static url(url: string) {
        return new S6Request({url});
    }

    public reauthenticate() {
        return new S6Request(Object.assign(this.options, {reauthenticate: true}));
    }
    public get() {
        return new S6Response(this.options);
    }
}

export interface S6RequestConfig {
    url?: string;
    data?: any;
    reauthenticate?: boolean;

}
